import { extendTheme, theme as baseTheme } from "@chakra-ui/react";

const config = {
  initialColorMode: "light",
  useSystemColorMode: false,
};

const colors = {
  brand: {
    50: "#f8f6fb", // light hover background
    100: "#e6e5ea", // table row bg (light)
    200: "#dcd3e6", // light alt bg
    300: "#b0a8bf", // light subtext
    400: "#97949f", // light table label text
    500: "#8671cc", // dark active sidebar
    600: "#7e6ca2",
    700: "#524789", // dark subtext
    800: "#3c326f", // tab background
    900: "#1b1845", // table/card bg dark
  },
  purple: {
    500: "#421e66", // primary light heading/action
    600: "#34174f", // sidebar dark
  },
  sidebar: {
    darkBg: "#34174f",
    lightActive: "#421e66",
  },
  background: {
    light: "#FFFFFF",
    dark: "#000024",
  },
  inputBg: {
    light: "#f8f6fb",
    dark: "#1e1530",
  },
  text: {
    light: "#421e66",
    dark: "#b5b5cd",
    muted: {
      light: "#b0a8bf",
      dark: "#524789",
    },
  },
};

const fonts = {
  heading: `'NeueHaas-Medium', sans-serif`,
  body: `'NeueHaas-Roman', sans-serif`,
};

const components = {
  Input: {
    baseStyle: {
      field: {
        _light: {
          bg: colors.inputBg.light,
          color: colors.text.light,
        },
        _dark: {
          bg: colors.inputBg.dark,
          color: colors.text.dark,
        },
      },
    },
  },
  Select: {
    baseStyle: {
      field: {
        _light: {
          bg: colors.inputBg.light,
          color: colors.text.light,
        },
        _dark: {
          bg: colors.inputBg.dark,
          color: colors.text.dark,
        },
      },
    },
  },
  Textarea: {
    baseStyle: {
      _light: {
        bg: colors.inputBg.light,
        color: colors.text.light,
      },
      _dark: {
        bg: colors.inputBg.dark,
        color: colors.text.dark,
      },
    },
  },
  Button: {
    ...baseTheme.components.Button,
    baseStyle: {
      fontWeight: "bold",
      borderRadius: "md",
    },
    variants: {
      ...baseTheme.components.Button.variants,
      solidBrand: {
        _light: {
          bg: colors.purple[500],
          color: "#fff",
          _hover: {
            bg: colors.brand[800],
          },
        },
        _dark: {
          bg: colors.brand[500],
          color: colors.brand[900],
          _hover: {
            bg: colors.brand[300],
          },
        },
      },
    },
    defaultProps: {
      variant: "solidBrand",
    },
  },
};

const theme = extendTheme({ config, colors, fonts, components });

export default theme;
